export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  image: string;
  category: string;
  features: string[];
  inStock: boolean;
}

export const getProductPath = (id: string): string => `/producto/${id}`;
